var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommentDots = function SvgCommentDots(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 23 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3C3C3B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.045 0h-6.09C3.56 0 0 3.582 0 8s3.561 8 7.955 8H22V8c0-4.418-3.561-8-7.955-8zM6.5 10C5.672 10 5 9.328 5 8.5S5.672 7 6.5 7 8 7.672 8 8.5c0 .398-.158.78-.44 1.06-.28.282-.662.44-1.06.44zm5 0c-.828 0-1.5-.672-1.5-1.5S10.672 7 11.5 7s1.5.672 1.5 1.5-.672 1.5-1.5 1.5zm5 0c-.828 0-1.5-.672-1.5-1.5S15.672 7 16.5 7s1.5.672 1.5 1.5-.672 1.5-1.5 1.5z",
    transform: "translate(-306 -826) translate(306 826)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommentDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/CommentDots.58ed5ccad1723a3cb2c616c4159309a7.blank.svg";